var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 19.802734 11 L 7.6035156 19.056641 L 19.800781 27.113281 L 7.6035156 35.171875 L 19.802734 43.228516 L 32 35.171875 L 19.804688 27.113281 L 32 19.056641 L 19.802734 11 z M 32 19.056641 L 44.195312 27.113281 L 32 35.171875 L 44.197266 43.228516 L 56.396484 35.171875 L 44.199219 27.113281 L 56.396484 19.056641 L 44.197266 11 L 32 19.056641 z M 32 37.9375 L 19.314453 46.46875 L 32 55 L 44.685547 46.46875 L 32 37.9375 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.9bf8567cfd92b531094cc1039418e91f.svg";
export { ForwardRef as ReactComponent };